import { memo } from 'react';

import { ProfileSetupForm } from '../../../../resources/components';
import { useProfileStepContainer } from './ProfileStepContainer.hooks';
import { ProfileStepContainerProps } from './ProfileStepContainer.types';

export const ProfileStepContainer = memo<ProfileStepContainerProps>((props) => {
    const { profileData, email } = props;

    const { isLoading, hasInvitations, handleProfileFormSubmit } = useProfileStepContainer(props);

    return (
        <ProfileSetupForm
            email={email}
            profileData={profileData}
            isLoading={isLoading}
            showPasswordField
            showPhoneField={!hasInvitations}
            showQuestions={!hasInvitations}
            showProgress={!hasInvitations}
            showSsoPanel={hasInvitations}
            onSubmit={handleProfileFormSubmit}
        />
    );
});

ProfileStepContainer.displayName = 'ProfileStepContainer';
